import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalStatusService} from '../../../shared/services/modal-status.service';
import {BookingService} from '../../../shared/services/booking.service';
import {EngineGuestsModalComponent} from '../engine-guests-modal/engine-guests-modal.component';

@Component({
  selector: 'app-engine-control-guests',
  templateUrl: './engine-control-guests.component.html',
  styleUrls: ['./engine-control-guests.component.scss']
})
export class EngineControlGuestsComponent implements OnInit {

  occupancy = this._bookingService.occupancy;

  constructor(private _modalService: NgbModal,
              private _bookingService: BookingService,
              private _modalStatusService: ModalStatusService) { }

  ngOnInit(): void {
  }

  open(): void {
    if (!this._modalService.hasOpenModals()) {
      this._modalStatusService.hasOpenModals.next(true);
      this._modalService.open(EngineGuestsModalComponent, {
        ariaLabelledBy: 'modal-engine',
        size: 'lg'
      }).result.finally(() => this._modalStatusService.hasOpenModals.next(false));
    }
  }

}
